import { SVGProps, Ref, forwardRef } from 'react';

export const RadioCircleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8" fill="currentColor" />
    </svg>
));
RadioCircleSize24Glyph.displayName = 'RadioCircleSize24Glyph';
